import Immutable from 'immutable'

import {
  createPartner,
} from '../../../records'

import { RECEIVE_SIGNUPS } from '../signup/constants'

// ------------------------------------
// Constants
// ------------------------------------
export const LOAD_PARTNER_ACCESS = 'inf/product/LOAD_PARTNER_ACCESS'
export const LOAD_PARTNERS = 'inf/product/LOAD_PARTNERS'
export const RECEIVE_PARTNERS = 'inf/partner/RECEIVE_PARTNERS'

// ------------------------------------
// Actions
// ------------------------------------
export const loadPartnerAccess = () => ({
  type: LOAD_PARTNER_ACCESS,
})
export const loadPartners = () => ({
  type: LOAD_PARTNERS,
})
export const receivePartners = partners => ({
  payload: { partners },
  type: RECEIVE_PARTNERS,
})

// ------------------------------------
// Helpers
// ------------------------------------

function buildPartnersFromSignupResponse(oldPartners, signups) {
  return signups.reduce((partners, signup) => {
    if (!signup.partner) {
      return partners
    }

    return replacePartner(partners, createPartner(signup.partner))
  }, oldPartners)
}

function replacePartner(partners, partner) {
  return partners
    .filter(search => partner.id !== search.id)
    .add(partner)
}

// ------------------------------------
// Reducer
// ------------------------------------
export const StateShape = Immutable.Record({
  partners: Immutable.Set(),
})

export default function reducer(state = new StateShape(), { payload, type }) {
  switch (type) {
    case RECEIVE_SIGNUPS:
      return state.set('partners', buildPartnersFromSignupResponse(
        state.partners,
        payload.signups,
      ))

    case RECEIVE_PARTNERS:
      return state.set('partners', payload.partners.reduce(
        (partners, partner) => replacePartner(partners, createPartner(partner)),
        state.partners,
      ))

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/partner/reducer.js